import { render, staticRenderFns } from "./PresaleDetail.vue?vue&type=template&id=00891fb1&"
import script from "./PresaleDetail.vue?vue&type=script&lang=js&"
export * from "./PresaleDetail.vue?vue&type=script&lang=js&"
import style0 from "./PresaleDetail.vue?vue&type=style&index=0&id=00891fb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports